var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForum24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgForum24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240-240v-120h520v-360h120v640L720-240zM80-280v-600h600v440H240zm80-193 47-47h393v-280H160zm0-47v-280z"
  })));
};
export default SvgForum24DpE3E3E3Fill0Wght400Grad0Opsz24;